import React, { useEffect } from "react"
import { beaconData, beaconProfile, parseQueryStrings } from "../utils/beacon"

import ContactIcon from "../images/headset.svg"
import Container from "../components/container/container"
import Content from "../components/content/content"
import Footer from "../components/footer/footer"
import Header from "../components/header/header"
import HelpIcon from "../images/help.svg"
import HeroText from "../components/hero-text/hero-text"
import LayoutService from "../components/layout-service/layout-service"
import SEO from "../components/seo/seo"
import ServiceContact from "../components/service-contact/service-contact"
import ServiceContactBox from "../components/service-contact-box/service-contact-box"
import ServiceQuestions from "../components/service-questions/service-questions"
import ServiceQuestionsList from "../components/service-questions-list/service-questions-list"
import ServiceQuestionsListItem from "../components/service-questions-list-item/service-questions-list-item"
import ServiceQuestionsMoreLink from "../components/service-questions-more-link/service-questions-more-link"
import TitleWithIcon from "../components/title-with-icon/title-with-icon"
import Wrapper from "../components/wrapper/wrapper"
import { useTranslation } from "react-i18next"

export default function Ayuda({ location }) {
  const { t, i18n } = useTranslation()

  const PageTitle = t("pages.help.title")
  const PageDescription = t("meta.description")

  const Questions = t("pages.help.questions.items")

  const renderQuestions = []

  for (let [index, faq] of Questions.entries()) {
    index++
    renderQuestions.push(
      <ServiceQuestionsListItem
        key={faq.title}
        title={faq.title}
        text={faq.text}
        id={`services-questions-item-${index}`}
      />
    )
  }

  const faqUrl = i18n.language === "en" ? "/faq/" : "/es/faq/"

  useEffect(() => {
    window.scrollTo(0, 0)

    if (location.pathname === "/help/") {
      i18n.changeLanguage("en")
    }

    /* Data Params */
    if (window.location.search) {
      const locationMeta = parseQueryStrings(window.location.search)

      const metaProfile = new beaconProfile(locationMeta)
      const metaData = new beaconData(locationMeta)

      // Set Beacon Profile
      window.Beacon("identify", metaProfile)
      // Set Beacon Form Prefill
      window.Beacon("prefill", metaProfile)

      // Set Season Data (Brand/OS/Refer/Device/Locale/IDs)
      window.Beacon("session-data", metaData)
    }
  }, [i18n, location])

  return (
    <Wrapper>
      <SEO title={PageTitle} description={PageDescription} />
      <HeroText
        title={t("pages.help.hero.title")}
        text={t("pages.help.hero.text")}
        textKey="pages.help.hero.text"
        id="services-hero"
      >
        <Container>
          <Header classVariant="headerText" location={location} />
        </Container>
      </HeroText>
      <Content classVariant="contentPage">
        <Container>
          <LayoutService>
            <ServiceQuestions>
              <TitleWithIcon
                title={t("pages.help.questions.title")}
                icon={HelpIcon}
                id="services-questions-title"
              />
              <ServiceQuestionsList>
                {renderQuestions}
                <ServiceQuestionsMoreLink
                  text={t("pages.help.questions.more-text")}
                  url={faqUrl}
                />
              </ServiceQuestionsList>
            </ServiceQuestions>
            <ServiceContact>
              <ServiceContactBox
                textHeader={t("pages.help.contact.text-header")}
                textFooter={t("pages.help.contact.text-footer")}
                buttonText={t("pages.help.contact.button-text")}
                email={t("pages.help.contact.email")}
              >
                <TitleWithIcon
                  title={t("pages.help.contact.title")}
                  icon={ContactIcon}
                />
              </ServiceContactBox>
            </ServiceContact>
          </LayoutService>
        </Container>
      </Content>
      <Footer />
    </Wrapper>
  )
}
